import CssSelectorStrategy from "./CssSelectorStrategy"
import SingleElementStrategy from "./SingleElementStrategy"
import IterableStrategy from "./IterableStrategy"
import LightqueryCollectionStrategy from "./LightqueryCollectionStrategy";

export const strategies = [
	new LightqueryCollectionStrategy(),
	new CssSelectorStrategy(),
	new SingleElementStrategy(),
	new IterableStrategy(),
];
